import React, { useEffect, useState } from 'react';
import { Container, Typography } from '@mui/material';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";

import '../common.scss';

import {
  useNavigate,
  useParams
} from 'react-router-dom';

import { useSelector } from "react-redux";

import { toast } from 'react-toastify';

import config from '../../config';

import Progressbar from './Progressbar';

function RepoConditionsChecklist() {

  const { repoId } = useParams();
  const decodedRepoId = repoId ? atob(repoId) : "";

  const navigate = useNavigate();

  const userInfo = useSelector(
    (state) => state.userInfo
  );

  const userId = userInfo?.id;

  const documentOptions = [

    "Vehicle Inventory Sheet",
    "Request Form",
    "Surrender Letter",
    "Registration Certificate Copy",
    "Insurance Copy",
    "Invoice Copy",
    "Photos Of Vehicle"

  ];

  const yesNoOptions = ["Yes", "No"];

  const conditionOptions = [
    "Good",
    "Average",
    "Bad",
    "Excellent"
  ];

  const [latVal, setLatVal] = useState(null);
  const [longVal, setLongVal] = useState(null);
  const [locationAddress, setLocationAddress] =
  useState('');
  const [showRepoChecklist, setShowRepoChecklist] = useState(false);
  const [auditData, setAuditData] = useState(null);
  const [repoCurrentStep, setRepoCurrentStep] = useState("Pending");
  const [vehiclePhotos, setVehiclePhotos] = useState([]);
  const [showPhotoPopup, setShowPhotoPopup] = useState(false);
  const [hasShownPhotoPopup, setHasShownPhotoPopup] = useState(false);

  // --- PRELOADER: tracks POST request in-flight state ---
  const [postLoading, setPostLoading] = useState(false);

  const [formData, setFormData] = useState({

    overall_vehicle_condition: "",

    detailed_condition_notes: "",

    // New Fields
    repair_required_for_sale: "No",
    repair_type: "",
    vehicle_saleable: "",
    inspection_date: "",

    documentation_checklist: [],

    supporting_documents: {},

    place_of_repossession: "",

    // Default Yes/No -> No
    rc_book: "No",
    tc_book: "No",
    insurance_certificate: "No",
    permit: "No",
    fitness_report: "No",
    tarpaulin: "No",
    tool_kit: "No",
    radio_stereo: "No",
    rope_rassi: "No",

    battery_make_number: "",
    electric: "",
    number_of_wheels: "",

    vehicle_condition: "",

    jack_available: "No",
    rod_available: "No",
    pana_available: "No",

    tyre_report: "",

    battery_no: "",
    controller_no: "",
    charger_no: "",

    front_left_side: "",
    front_left_tyre_make: "",

    front_right_side: "",
    front_right_tyre_make: "",

    rear_left_side: "",
    rear_left_tyre_make: "",

    rear_right_side: "",
    rear_right_tyre_make: "",

    right_side_mirror: "No",
    rear_mirror: "No",
    left_side_mirror: "No",

    spare_tyre: "",
    spare_tyre_make: "",

    additional_information: ""

  });

  useEffect(() => {

    fetchChecklist();
    fetchRepoProgress();
    console.log("Requesting location...");

    if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition(

  (position) => {
   console.log("Location captured");
    const latitude =
      position.coords.latitude;

    const longitude =
      position.coords.longitude;

    console.log("LATITUDE", latitude);
    console.log("LONGITUDE", longitude);

    setLatVal(latitude);
    setLongVal(longitude);

    fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    )
      .then((res) => res.json())
      .then((data) => {

        setLocationAddress(
          data.display_name || ''
        );

      });

  },

  (error) => {

    console.log(error);

    toast.error(
      "Please allow location access"
    );

  },

  {
    enableHighAccuracy: true,
    timeout: 30000,
    maximumAge: 0
  }

);

    } else {

        toast.error(
        "Location not supported"
        );

    }

    }, []);

  const fetchChecklist = async () => {

    try {

      const res = await fetch(
        `${config.API_BASE_URL}getRepoChecklist/${decodedRepoId}`
      );

      const result = await res.json();

      if (result.status && result.data) {

        const data = result.data;
        setAuditData(data);

        setFormData({

          overall_vehicle_condition:
            data.overall_vehicle_condition || '',

          detailed_condition_notes:
            data.detailed_condition_notes || '',

          documentation_checklist:
        Array.isArray(
            data.documentation_checklist
        )
            ? data.documentation_checklist
            : (
                data.documentation_checklist
                ? JSON.parse(
                    data.documentation_checklist
                    )
                : []
            ),

          supporting_documents:
        typeof data.supporting_documents === "object"
            ? data.supporting_documents
            : (
                data.supporting_documents
                ? JSON.parse(
                    data.supporting_documents
                    )
                : {}
            ),

          place_of_repossession:
            data.place_of_repossession || '',

          rc_book: data.rc_book || '',
          tc_book: data.tc_book || '',
          insurance_certificate:
            data.insurance_certificate || '',

          permit: data.permit || '',
          fitness_report:
            data.fitness_report || '',

          tarpaulin: data.tarpaulin || '',
          tool_kit: data.tool_kit || '',

          radio_stereo:
            data.radio_stereo || '',

          rope_rassi:
            data.rope_rassi || '',

          battery_make_number:
            data.battery_make_number || '',

          electric:
            data.electric || '',

          number_of_wheels:
            data.number_of_wheels || '',

          vehicle_condition:
            data.vehicle_condition || '',

          jack_available:
            data.jack_available || '',

          rod_available:
            data.rod_available || '',

          pana_available:
            data.pana_available || '',

          tyre_report:
            data.tyre_report || '',

          battery_no:
            data.battery_no || '',

          controller_no:
            data.controller_no || '',

          charger_no:
            data.charger_no || '',

          front_left_side:
            data.front_left_side || '',

          front_left_tyre_make:
            data.front_left_tyre_make || '',

          front_right_side:
            data.front_right_side || '',

          front_right_tyre_make:
            data.front_right_tyre_make || '',

          rear_left_side:
            data.rear_left_side || '',

          rear_left_tyre_make:
            data.rear_left_tyre_make || '',

          rear_right_side:
            data.rear_right_side || '',

          rear_right_tyre_make:
            data.rear_right_tyre_make || '',

          right_side_mirror:
            data.right_side_mirror || '',

          rear_mirror:
            data.rear_mirror || '',

          left_side_mirror:
            data.left_side_mirror || '',

          spare_tyre:
            data.spare_tyre || '',

          spare_tyre_make:
            data.spare_tyre_make || '',

            repair_required_for_sale:
        data.repair_required_for_sale || "No",

        repair_type:
            data.repair_type || "",

        vehicle_saleable:
            data.vehicle_saleable || "",

        inspection_date:
            data.inspection_date || "",

          additional_information:
            data.additional_information || ''

        });

      }

    } catch {

      toast.error("Failed to fetch checklist");

    }

  };

  const fetchRepoProgress = async () => {

  try {

    const res = await fetch(

      `${config.API_BASE_URL}get-repo-progress-flow?repo_id=${decodedRepoId}`

    );

    const result = await res.json();

    if (result.status) {

      setRepoCurrentStep(
        result.current_step
      );

    }

  } catch (error) {

    console.log(error);

  }

  };

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

  };

  const handleChecklistChange = (item) => {

    let updated = [
      ...formData.documentation_checklist
    ];

    if (updated.includes(item)) {

      updated = updated.filter(
        (i) => i !== item
      );

    } else {

      updated.push(item);

    }

    setFormData(prev => ({
      ...prev,
      documentation_checklist: updated
    }));

  };

  const handleFileChange = (item, file) => {

  setFormData((prev) => ({

    ...prev,

    supporting_documents: {

      ...prev.supporting_documents,

      [item]: file

    }

  }));

};

const handleSave = async (statusType) => {

  if (statusType === "completed" && !formData.inspection_date) {
      toast.error("Please select Inspection Date");
      return;
  }

  if (statusType === "completed" && vehiclePhotos.length < 5) {
      toast.error(
          "Please upload at least 5 vehicle photos before proceeding."
      );
      return;
  }

  // --- PRELOADER: show overlay before POST request ---
  setPostLoading(true);

  try {

  if (latVal === null || longVal === null) {
    toast.error("Location not captured yet");
    return;
  }

  const formPayload = new FormData();

  formPayload.append("repo_id", decodedRepoId);
  formPayload.append("overall_vehicle_condition", formData.overall_vehicle_condition);
  formPayload.append("detailed_condition_notes", formData.detailed_condition_notes);
  formPayload.append("place_of_repossession", formData.place_of_repossession);

  formPayload.append("rc_book", formData.rc_book);
  formPayload.append("tc_book", formData.tc_book);
  formPayload.append("insurance_certificate", formData.insurance_certificate);
  formPayload.append("permit", formData.permit);
  formPayload.append("fitness_report", formData.fitness_report);
  formPayload.append("tarpaulin", formData.tarpaulin);
  formPayload.append("tool_kit", formData.tool_kit);
  formPayload.append("radio_stereo", formData.radio_stereo);
  formPayload.append("rope_rassi", formData.rope_rassi);

  formPayload.append("battery_make_number", formData.battery_make_number);
  formPayload.append("electric", formData.electric);
  formPayload.append("number_of_wheels", formData.number_of_wheels);

  formPayload.append("vehicle_condition", formData.vehicle_condition);

  formPayload.append("jack_available", formData.jack_available);
  formPayload.append("rod_available", formData.rod_available);
  formPayload.append("pana_available", formData.pana_available);

  formPayload.append("tyre_report", formData.tyre_report);

  formPayload.append("battery_no", formData.battery_no);
  formPayload.append("controller_no", formData.controller_no);
  formPayload.append("charger_no", formData.charger_no);

  formPayload.append("front_left_side", formData.front_left_side);
  formPayload.append("front_left_tyre_make", formData.front_left_tyre_make);

  formPayload.append("front_right_side", formData.front_right_side);
  formPayload.append("front_right_tyre_make", formData.front_right_tyre_make);

  formPayload.append("rear_left_side", formData.rear_left_side);
  formPayload.append("rear_left_tyre_make", formData.rear_left_tyre_make);

  formPayload.append("rear_right_side", formData.rear_right_side);
  formPayload.append("rear_right_tyre_make", formData.rear_right_tyre_make);

  formPayload.append("right_side_mirror", formData.right_side_mirror);
  formPayload.append("rear_mirror", formData.rear_mirror);
  formPayload.append("left_side_mirror", formData.left_side_mirror);

  formPayload.append("spare_tyre", formData.spare_tyre);
  formPayload.append("spare_tyre_make", formData.spare_tyre_make);

  formPayload.append("repair_required_for_sale", formData.repair_required_for_sale);
  formPayload.append("repair_type", formData.repair_type);
  formPayload.append("vehicle_saleable", formData.vehicle_saleable);
  formPayload.append("inspection_date", formData.inspection_date);

  formPayload.append("additional_information", formData.additional_information);

  formPayload.append("latitude", latVal);
  formPayload.append("longitude", longVal);
  formPayload.append("location_address", locationAddress);

  formPayload.append("checklist_status", statusType);
  formPayload.append("user_id", userId);

  // Documentation Checklist
  formData.documentation_checklist.forEach((doc) => {
    formPayload.append("documentation_checklist[]", doc);
  });

  // Supporting Documents
  Object.keys(formData.supporting_documents).forEach((key) => {
    const file = formData.supporting_documents[key];
    if (file) {
      formPayload.append(`supporting_documents[${key}]`, file);
    }
  });

  // Vehicle Photos (Multiple)
  vehiclePhotos.forEach((file) => {
    formPayload.append("vehicle_photos[]", file);
  });

  const res = await fetch(`${config.API_BASE_URL}saveRepoChecklist`, {
    method: "POST",
    body: formPayload
  });

  const result = await res.json();

  if (result.status) {

    toast.success(result.message);

    if (statusType === "completed") {
      navigate(`/dashboard/schedule-inspection/${btoa(decodedRepoId)}`);
    }

  } else {

    toast.error(result.message);

  }

} catch (error) {

  console.error(error);

  toast.error("Failed to save");

} finally {

    // --- PRELOADER: hide overlay after POST finishes ---
    setPostLoading(false);

  }

};

const renderRadio = (
  label,
  name,
  options = yesNoOptions
) => (

  <div className="col-md-4 mb-3">

    <label className="fw-bold d-block mb-2">
      {label}
    </label>

    <div className="d-flex gap-4 mt-2">

      {options.map((option) => (

        <div
          className="form-check"
          key={option}
        >

          <input
            className="form-check-input"
            type="radio"
            name={name}
            id={`${name}_${option}`}
            value={option}
            checked={
                (formData[name] || "No") === option
            }
            onChange={handleChange}
          />

          <label
            className="form-check-label"
            htmlFor={`${name}_${option}`}
          >
            {option}
          </label>

        </div>

      ))}

    </div>

  </div>

);

  const handleVehiclePhotos = (e) => {

      const files = Array.from(e.target.files);

      if (!files.length) return;

      setVehiclePhotos(prev => [...prev, ...files]);

      if (!hasShownPhotoPopup) {

          setShowPhotoPopup(true);

          setHasShownPhotoPopup(true);

      }

  };

  return (

    <Container>

      {/* --- PRELOADER OVERLAY: shown during POST request --- */}
      {postLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.85)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(3px)'
          }}
        >
          <div
            style={{
              width: '56px',
              height: '56px',
              border: '5px solid #e0e0e0',
              borderTop: '5px solid #1976d2',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }}
          />
          <p style={{ marginTop: '18px', fontWeight: 600, color: '#1976d2', fontSize: '15px' }}>
            Saving checklist, please wait...
          </p>
          {[1,2,3].map(i => (
            <div
              key={i}
              style={{
                width: '320px',
                height: '14px',
                borderRadius: '6px',
                marginTop: '10px',
                background: 'linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)',
                backgroundSize: '400% 100%',
                animation: 'shimmer 1.4s infinite'
              }}
            />
          ))}
          <style>{`
            @keyframes spin { to { transform: rotate(360deg); } }
            @keyframes shimmer { 0%{background-position:100% 0} 100%{background-position:-100% 0} }
          `}</style>
        </div>
      )}
      {/* --- END PRELOADER OVERLAY --- */}


      <div className="flex-container mb-3">

        <Typography variant="h4">
          Repo Conditions Checklist
        </Typography>

      </div>
      <div className="mb-4">

        <Progressbar currentStep={repoCurrentStep} />

      </div>

      <div id="main-wrap">

        <div className="row">

          {/* Overall Condition */}
          <div className="col-md-6 mb-3">

            <label className="fw-bold">
              Overall Vehicle Condition *
            </label>

            <select
              className="form-control"
              name="overall_vehicle_condition"
              value={
                formData.overall_vehicle_condition
              }
              onChange={handleChange}
            >

              <option value="">
                Select
              </option>

              <option value="Good">
                Good
              </option>

              <option value="Average">
                Average
              </option>

              <option value="Bad">
                Bad
              </option>
              <option value="Excellent">
                  Excellent
              </option>

            </select>

          </div>
        
          <div className="col-md-4 mb-3">

            <label className="fw-bold">
                Repair Required For Sale
            </label>

            <select
                className="form-control"
                name="repair_required_for_sale"
                value={formData.repair_required_for_sale}
                onChange={handleChange}
            >

                <option value="No">No</option>
                <option value="Yes">Yes</option>

            </select>

        </div>

        {
        formData.repair_required_for_sale === "Yes" && (

        <div className="col-md-4 mb-3">

            <label className="fw-bold">
                If Repair Required
            </label>

            <select
                className="form-control"
                name="repair_type"
                value={formData.repair_type}
                onChange={handleChange}
            >

                <option value="">
                    Select
                </option>

                <option value="Minor Repairing">
                    Minor Repairing
                </option>

                <option value="Major Repairing">
                    Major Repairing
                </option>

            </select>

        </div>

        )
        }

        <div className="col-md-4 mb-3">

            <label className="fw-bold">
                Vehicle Saleable
            </label>

            <select
                className="form-control"
                name="vehicle_saleable"
                value={formData.vehicle_saleable}
                onChange={handleChange}
            >

                <option value="">
                    Select
                </option>

                <option value="Saleable">
                    Saleable
                </option>

                <option value="Not Saleable">
                    Not Saleable
                </option>

            </select>

        </div>
          {/* Notes */}
          <div className="col-md-12 mb-3">

            <label className="fw-bold">
              Detailed Condition Notes *
            </label>

            <textarea
              className="form-control"
              rows="4"
              name="detailed_condition_notes"
              value={
                formData.detailed_condition_notes
              }
              onChange={handleChange}
            />

          </div>

          <div className="col-md-12 mb-4">

            <label className="fw-bold d-block mb-2">
                Vehicle Photos <span className="text-danger">(Minimum 5 Required)</span>
            </label>

            <button
                type="button"
                className="btn btn-warning px-4"
                onClick={() => document.getElementById("vehiclePhotosInput").click()}
            >
                <i className="bi bi-images me-2"/>
                Upload Vehicle Photos
            </button>

            <input
                id="vehiclePhotosInput"
                type="file"
                accept="image/*"
                multiple
                style={{ display: "none" }}
                onChange={handleVehiclePhotos}
            />

            <div className="mt-2">

                <span
                    className={`badge ${
                        vehiclePhotos.length >= 5
                            ? "bg-success"
                            : "bg-warning text-dark"
                    }`}
                >
                    {vehiclePhotos.length}  Photos Selected
                </span>

            </div>

        </div>

        {vehiclePhotos.length > 0 && (

          <div className="mt-3">

              <h6 className="fw-bold mb-3">

                  Selected Photos ({vehiclePhotos.length})

              </h6>

              <div className="row">

                  {vehiclePhotos.map((img, index) => (

                      <div className="col-lg-2 col-md-3 col-4 mb-3" key={index}>

                          <div className="position-relative">

                              <img
                                  src={URL.createObjectURL(img)} alt='ckers finanace'
                                  className="img-fluid rounded border shadow-sm"
                                  style={{
                                      height: 120,
                                      width: "100%",
                                      objectFit: "cover"
                                  }}
                              />

                              <span
                                  className="badge bg-dark position-absolute"
                                  style={{
                                      top: 5,
                                      right: 5
                                  }}
                              >
                                  {index + 1}
                              </span>

                          </div>

                      </div>

                  ))}

              </div>

          </div>

          )}

          {/* Documentation Checklist */}
          <div className="col-md-12 mb-3">

            <label className="fw-bold d-block mb-2">
              Documentation Checklist *
            </label>

            {documentOptions.map((item) => (

              <div
                className="form-check mb-2"
                key={item}
              >

                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    formData
                      .documentation_checklist
                      .includes(item)
                  }
                  onChange={() =>
                    handleChecklistChange(item)
                  }
                />

                <label className="form-check-label">
                  {item}
                </label>

              </div>

            ))}

          </div>

          {/* Uploads */}
          <div className="col-md-12 mb-3">

            <label className="fw-bold d-block mb-2">
              Upload Supporting Photos /
              Documents
            </label>

            {Array.isArray(
              formData.documentation_checklist
            )
              ? formData.documentation_checklist
                  .map((item) => (

              <div
                className="mb-3"
                key={item}
              >

                <label className="d-block mb-1">
                  Upload {item}
                </label>

                <input
                    type="file"
                    className="form-control"
                    name={`supporting_documents[${item}]`}
                    onChange={(e) =>
                        handleFileChange(
                        item,
                        e.target.files[0]
                        )
                    }
                    />

              </div>

            ))
            : null}

          </div>


          {/* Repo Checklist */}
         {/* Repo Checklist Header */}
            <div className="col-md-12 mb-3">

            <div
                className="
                d-flex
                justify-content-between
                align-items-center
                border
                rounded
                p-3
                bg-light
                "
            >

                <h5 className="mb-0">
                Repo Checklist
                </h5>

                <button
                type="button"
                className="
                    btn
                    btn-sm
                    btn-outline-secondary
                "
                onClick={() =>
                    setShowRepoChecklist(
                    !showRepoChecklist
                    )
                }
                >

                <i className="bi bi-three-dots-vertical"/>

                </button>

            </div>

            </div>

            {showRepoChecklist && (
            <>

          <div className="col-md-6 mb-3">

            <label className="fw-bold">
              Place Of Repossession
            </label>

            <input
              type="text"
              className="form-control"
              name="place_of_repossession"
              value={
                formData.place_of_repossession
              }
              onChange={handleChange}
            />

          </div>

          {renderRadio(
            "RC Book",
            "rc_book"
          )}

          {renderRadio(
            "TC Book",
            "tc_book"
          )}

          {renderRadio(
            "Insurance Certificate",
            "insurance_certificate"
          )}

          {renderRadio(
            "Permit",
            "permit"
          )}

          {renderRadio(
            "Fitness Report",
            "fitness_report"
          )}

          {renderRadio(
            "Tarpaulin",
            "tarpaulin"
          )}

          {renderRadio(
            "Tool Kit",
            "tool_kit"
          )}

          {renderRadio(
            "Radio / Stereo",
            "radio_stereo"
          )}

          {renderRadio(
            "Rope / Rassi",
            "rope_rassi"
          )}

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Battery Make Number
            </label>

            <input
              type="text"
              className="form-control"
              name="battery_make_number"
              value={
                formData.battery_make_number
              }
              onChange={handleChange}
            />

          </div>

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Electric
            </label>

            <input
              type="text"
              className="form-control"
              name="electric"
              value={formData.electric}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Number Of Wheels
            </label>

            <input
              type="text"
              className="form-control"
              name="number_of_wheels"
              value={
                formData.number_of_wheels
              }
              onChange={handleChange}
            />

          </div>

          {renderRadio(
            "Vehicle Condition",
            "vehicle_condition",
            ["Running", "Trochen"]
          )}

          {renderRadio(
            "Jack",
            "jack_available"
          )}

          {renderRadio(
            "Road",
            "rod_available"
          )}

          {renderRadio(
            "Pana",
            "pana_available"
          )}

          <div className="col-md-12 mb-3">

            <label className="fw-bold">
              Tyre Report
            </label>

            <textarea
              className="form-control"
              rows="3"
              name="tyre_report"
              value={formData.tyre_report}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Battery No
            </label>

            <input
              type="text"
              className="form-control"
              name="battery_no"
              value={formData.battery_no}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Controller No
            </label>

            <input
              type="text"
              className="form-control"
              name="controller_no"
              value={formData.controller_no}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Charger No
            </label>

            <input
              type="text"
              className="form-control"
              name="charger_no"
              value={formData.charger_no}
              onChange={handleChange}
            />

          </div>

          {renderRadio(
            "Front Left Side",
            "front_left_side",
            conditionOptions
          )}

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Front Left Tyre Make
            </label>

            <input
              type="text"
              className="form-control"
              name="front_left_tyre_make"
              value={
                formData.front_left_tyre_make
              }
              onChange={handleChange}
            />

          </div>

          {renderRadio(
            "Front Right Side",
            "front_right_side",
            conditionOptions
          )}

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Front Right Tyre Make
            </label>

            <input
              type="text"
              className="form-control"
              name="front_right_tyre_make"
              value={
                formData.front_right_tyre_make
              }
              onChange={handleChange}
            />

          </div>

          {renderRadio(
            "Rear Left Side",
            "rear_left_side",
            conditionOptions
          )}

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Rear Left Tyre Make
            </label>

            <input
              type="text"
              className="form-control"
              name="rear_left_tyre_make"
              value={
                formData.rear_left_tyre_make
              }
              onChange={handleChange}
            />

          </div>

          {renderRadio(
            "Rear Right Side",
            "rear_right_side",
            conditionOptions
          )}

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Rear Right Tyre Make
            </label>

            <input
              type="text"
              className="form-control"
              name="rear_right_tyre_make"
              value={
                formData.rear_right_tyre_make
              }
              onChange={handleChange}
            />

          </div>

          {renderRadio(
            "Right Side Mirror",
            "right_side_mirror"
          )}

          {renderRadio(
            "Rear Mirror",
            "rear_mirror"
          )}

          {renderRadio(
            "Left Side Mirror",
            "left_side_mirror"
          )}

          {renderRadio(
            "Spare Tyre",
            "spare_tyre",
            conditionOptions
          )}

          <div className="col-md-4 mb-3">

            <label className="fw-bold">
              Spare Tyre Make
            </label>

            <input
              type="text"
              className="form-control"
              name="spare_tyre_make"
              value={
                formData.spare_tyre_make
              }
              onChange={handleChange}
            />

          </div>
          <div className="col-md-4 mb-3">

            <label className="fw-bold">
                Inspection Date *
            </label>

            <input
                type="date"
                className="form-control"
                name="inspection_date"
                value={formData.inspection_date}
                onChange={handleChange}
            />

        </div>

          <div className="col-md-12 mb-4">

            <label className="fw-bold">
              Additional Information
            </label>

            <textarea
              className="form-control"
              rows="4"
              name="additional_information"
              value={
                formData.additional_information
              }
              onChange={handleChange}
            />

          </div>

          <div className="col-md-12 mb-4">

  <div className="d-flex gap-2 justify-content-end">

    {/* --- PRELOADER: buttons disabled while POST is in-flight --- */}
    <button
      type="button"
      className="btn btn-warning"
      onClick={() =>
        handleSave("draft")
      }
      disabled={postLoading}
      style={{ opacity: postLoading ? 0.7 : 1 }}
    >
      {postLoading ? 'Saving...' : 'Save As Draft'}
    </button>

    <button
    type="button"
    className="btn btn-success"
    onClick={() => handleSave("completed")}
    disabled={postLoading}
    style={{ opacity: postLoading ? 0.7 : 1 }}
    >
    {postLoading ? 'Saving...' : 'Complete'}
    </button>

  </div>

</div>
    </>
    )}
          
        {/* Buttons */}
        <div className="col-md-12">

        <div className="d-flex gap-2 justify-content-end">

            <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
            >
            Back
            </button>

            {/* --- PRELOADER: Save button disabled while POST is in-flight --- */}
            <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleSave("completed")}
                disabled={postLoading}
                style={{ opacity: postLoading ? 0.7 : 1 }}
                >
                {postLoading ? 'Saving...' : 'Save'}
                </button>

        </div>

        </div>

        {auditData && (

        <div className="col-md-12 mt-4">

            <div className="card shadow-sm">

            <div className="card-header bg-light">

                <h5 className="mb-0">
                Audit History
                </h5>

            </div>

            <div className="card-body">

                <div className="row">

                <div className="col-md-4 mb-3">

                    <strong>
                    Created Date:
                    </strong>

                    <div>
                    {auditData.created_at || "-"}
                    </div>

                </div>

                <div className="col-md-4 mb-3">

                    <strong>
                        Created By:
                    </strong>

                    <div>
                        {auditData.created_by_name || "-"}
                    </div>

                    </div>

                <div className="col-md-4 mb-3">

                    <strong>
                    Updated Date:
                    </strong>

                    <div>
                    {auditData.updated_at || "-"}
                    </div>

                </div>

                <div className="col-md-4 mb-3">

                    <strong>
                        Updated By:
                    </strong>

                    <div>
                        {auditData.updated_by_name || "-"}
                    </div>

                </div>

                <div className="col-md-4 mb-3">

                    <strong>
                    Stage:
                    </strong>

                    <div>
                    {auditData.checklist_status || "-"}
                    </div>

                </div>

                <div className="col-md-4 mb-3">

                    <strong>
                    Latitude:
                    </strong>

                    <div>
                    {auditData.latitude || "-"}
                    </div>

                </div>

                <div className="col-md-4 mb-3">

                    <strong>
                    Longitude:
                    </strong>

                    <div>
                    {auditData.longitude || "-"}
                    </div>

                </div>

                <div className="col-md-12 mb-3">

                    <strong>
                    Location:
                    </strong>

                    <div>
                    {auditData.location_address || "-"}
                    </div>

                </div>

                </div>

            </div>

            </div>

        </div>

        )}

        </div>

      </div>

      {showPhotoPopup && (

        <div
            className="modal fade show"
            style={{
                display: "block",
                background: "rgba(0,0,0,.5)"
            }}
        >

            <div className="modal-dialog modal-dialog-centered">

                <div className="modal-content">

                    <div className="modal-header">

                        <h5>
                            Vehicle Photos Required
                        </h5>

                    </div>

                    <div className="modal-body">

                      <p className="mb-3">

                          <strong>Please upload at least 5 clear vehicle photographs.</strong>

                      </p>

                      <p className="mb-2">
                          Make sure the uploaded images include:
                      </p>

                      <ul className="mb-0">

                          <li>Front View</li>

                          <li>Rear View</li>

                          <li>Left Side View</li>

                          <li>Right Side View</li>

                          <li>Interior / Cabin</li>

                          <li>Dashboard</li>

                          <li>Any Damages (if applicable)</li>

                      </ul>

                  </div>

                    <div className="modal-footer">

                        <button
                            className="btn btn-warning"
                            onClick={() => setShowPhotoPopup(false)}
                        >
                            Continue
                        </button>

                    </div>

                </div>

            </div>

        </div>

        )}

    </Container>

  );
}

export default RepoConditionsChecklist;